import router from "@/router";
import axios from "axios";
// import store from "../store/index";

axios.interceptors.request.use(config => {
    config.baseURL = `${process.env.VUE_APP_BASE_URL}/api/`,
        config.headers.Authorization = ` Bearer ${localStorage.getItem('accessToken') !== null ? localStorage.getItem('accessToken') : false} `
    return config;
})

axios.interceptors.response.use((response) => {
    return response
}, (error) => {
    if (error.response.status === 401) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('userData');
        router.push('/login')
    }
   
    if (error.response.status === 500) {
        router.push('/error-404')
    }
    return Promise.reject(error);
})

export default axios;